<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-9">                  
                <div class="row mb-5">                    
                    <div class="col-lg-12 mt-lg-0 mt-4">
                        <studebook-status-detail />                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import StudebookStatusDetail from "./components/StudebookStatusDetail.vue"

export default {
    name: 'StudebookStatus_edit_page',
    components: {        
        StudebookStatusDetail
    },
    data() {
        return {
            Id: '',
            studebookstatus: [],
            gets: []
        }
    },
    async mounted() {
        this.id = this.$route.params.id;   
        console.log('Route ID:', this.id);   
    },
}
</script>